import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonList, ButtonListItemSize, Group, GroupGutter, Text, TextColor } from '@as/cotopaxi';
import { capitalize } from '@as-react/common-utils';
export const FilterLink = ({ items, toggleFilterValue }) => (_jsx(ButtonList, { stateLabel: true, size: ButtonListItemSize.MEDIUM, buttons: items.map((item) => ({
        key: item.filterKey,
        noBubble: true,
        text: (_jsxs(Group, { gutter: GroupGutter.SMALL, children: [_jsx(Text, { inline: true, emphasized: item.active, children: capitalize(item.name) }), _jsxs(Text, { inline: true, color: TextColor.SUBTLE, children: ["(", item.itemCount, ")"] })] })),
        onClick: (e) => toggleFilterValue(e, item),
    })) }));
